/**
 * 组件路径接口定义
 */
export interface ComponentPath {
  key: string;
  path: string;
  module?: string;
  component?: any;
}

/**
 * 菜单树数据项接口定义
 */
export interface MenuItem {
  path: string;
  name: string;
  component?: string;
  children?: MenuItem[];
  meta?: {
    title?: string;
    icon?: string;
    [key: string]: any;
  };
  [key: string]: any;
}

/**
 * 路由配置项接口定义
 */
export interface RouteConfig {
  path: string;
  name: string;
  component: any;
  children?: RouteConfig[];
  meta?: {
    title?: string;
    icon?: string;
    [key: string]: any;
  };
  [key: string]: any;
}

/**
 * 业务模块组件路径数组
 * 集中管理所有业务组件的路径，便于维护
 * 新增路由在此定义component路径，动态路由需要匹配，直接拼接不能正常获取
 */
export const componentPathArray: ComponentPath[] = [
  // 系统管理模块
  {
    key: "accountMgtPage",
    path: "/systemMgt/accountMgtPage/index.vue",
    component: () => import("@/views/systemMgt/accountMgtPage/index.vue"),
    module: "systemMgt",
  },
  {
    key: "rolePage",
    path: "/systemMgt/rolePage/index.vue",
    component: () => import("@/views/systemMgt/rolePage/index.vue"),
    module: "systemMgt",
  },
  {
    key: "menuPage",
    path: "/systemMgt/menuPage/index.vue",
    component: () => import("@/views/systemMgt/menuPage/index.vue"),
    module: "systemMgt",
  },
  {
    key: "deptPage",
    path: "/systemMgt/deptPage/index.vue",
    component: () => import("@/views/systemMgt/deptPage/index.vue"),
    module: "systemMgt",
  },
  {
    key: "dictPage",
    path: "/systemMgt/dictPage/index.vue",
    component: () => import("@/views/systemMgt/dictPage/index.vue"),
    module: "systemMgt",
  },
  {
    key: "tenantPage",
    path: "/systemMgt/tenantPage/index.vue",
    component: () => import("@/views/systemMgt/tenantPage/index.vue"),
    module: "systemMgt",
  },
  {
    key: "loginInfoPage",
    path: "/systemMgt/loginInfoPage/index.vue",
    component: () => import("@/views/systemMgt/loginInfoPage/index.vue"),
    module: "systemMgt",
  },
  {
    key: "opLogPage",
    path: "/systemMgt/opLogPage/index.vue",
    component: () => import("@/views/systemMgt/opLogPage/index.vue"),
    module: "systemMgt",
  },
  {
    key: "pageConfig",
    path: "/systemMgt/pageConfigPage/index.vue",
    component: () => import("@/views/systemMgt/pageConfigPage/index.vue"),
    module: "systemMgt",
  },
  {
    key: "mqMessageMgt",
    path: "/systemMgt/mqMessageMgt/index.vue",
    component: () => import("@/views/systemMgt/mqMessageMgt/index.vue"),
    module: "systemMgt",
  },
  {
    key: "noticeMgt",
    path: "/systemMgt/noticeMgt/index.vue",
    component: () => import("@/views/systemMgt/noticeMgt/index.vue"),
    module: "systemMgt",
  },
  {
    key: "smsConfigPage",
    path: "/systemMgt/smsConfigPage/index.vue",
    component: () => import("@/views/systemMgt/smsConfigPage/index.vue"),
    module: "systemMgt",
  },
  {
    key: "paySettingPage",
    path: "/systemMgt/paySettingPage/index.vue",
    component: () => import("@/views/systemMgt/paySettingPage/index.vue"),
    module: "systemMgt",
  },


  // 用户管理模块
  {
    key: "userPage",
    path: "/userMgt/userPage/index.vue",
    component: () => import("@/views/userMgt/userPage/index.vue"),
    module: "userMgt",
  },
  {
    key: "userListPage",
    path: "/userMgt/userListPage/index.vue",
    component: () => import("@/views/userMgt/userListPage/index.vue"),
    module: "userMgt",
  },
  {
    key: "orderPage",
    path: "/userMgt/orderPage/index.vue",
    component: () => import("@/views/userMgt/orderPage/index.vue"),
    module: "userMgt",
  },
  {
    key: "equipmentPage",
    path: "/userMgt/equipmentPage/index.vue",
    component: () => import("@/views/userMgt/equipmentPage/index.vue"),
    module: "userMgt",
  },
  {
    key: "equipmentTransferPage",
    path: "/userMgt/equipmentTransferPage/index.vue",
    component: () => import("@/views/userMgt/equipmentTransferPage/index.vue"),
    module: "userMgt",
  },
  {
    key: "equipmentTransferWhitelistPage",
    path: "/userMgt/equipmentTransferWhitelistPage/index.vue",
    component: () => import("@/views/userMgt/equipmentTransferWhitelistPage/index.vue"),
    module: "userMgt",
  },
  {
    key: "userFilePage",
    path: "/userMgt/userFilePage/index.vue",
    component: () => import("@/views/userMgt/userFilePage/index.vue"),
    module: "userMgt",
  },
  {
    key: "equipmentResetRecordPage",
    path: "/userMgt/equipmentResetRecordPage/index.vue",
    component: () => import("@/views/userMgt/equipmentResetRecordPage/index.vue"),
    module: "userMgt",
  },
   {
    key: "customerProxyRecordPage",
    path: "/userMgt/customerProxyRecordPage/index.vue",
    component: () => import("@/views/userMgt/customerProxyRecordPage/index.vue"),
    module: "userMgt",
  },
   {
    key: "operationLog",
    path: "/userMgt/operationLog/index.vue",
    component: () => import("@/views/userMgt/operationLog/index.vue"),
    module: "operationLogMgt",
  },
   {
    key: "cloudOperationLog",
    path: "/userMgt/cloudOperationLog/index.vue",
    component: () => import("@/views/userMgt/cloudOperationLog/index.vue"),
    module: "operationLogMgt",
  },
   {
    key: "clientLoginInfoPage",
    path: "/userMgt/clientLoginInfoPage/index.vue",
    component: () => import("@/views/userMgt/clientLoginInfoPage/index.vue"),
    module: "clientLoginInfoMgt",
  },
   {
    key: "feedBackPage",
    path: "/userMgt/feedBackPage/index.vue",
    component: () => import("@/views/userMgt/feedBackPage/index.vue"),
    module: "feedbackMgt",
  },

  // 商品管理模块
  {
    key: "productInfoPage",
    path: "/productMgt/productInfoPage/index.vue",
    component: () => import("@/views/productMgt/productInfoPage/index.vue"),
    module: "productMgt",
  },
  {
    key: "productNormsConfigPage",
    path: "/productMgt/productNormsConfigPage/index.vue",
    component: () => import("@/views/productMgt/productNormsConfigPage/index.vue"),
    module: "productMgt",
  },
  {
    key: "resourcePoolPage",
    path: "/productMgt/resourcePoolPage/index.vue",
    component: () => import("@/views/productMgt/resourcePoolPage/index.vue"),
    module: "productMgt",
  },
  {
    key: "normsParamsConfigPage",
    path: "/productMgt/normsParamsConfigPage/index.vue",
    component: () => import("@/views/productMgt/normsParamsConfigPage/index.vue"),
    module: "productMgt",
  },
  {
    key: "redemptionCodeGeneratePage",
    path: "/productMgt/redemptionCodeGeneratePage/index.vue",
    component: () => import("@/views/productMgt/redemptionCodeGeneratePage/index.vue"),
    module: "productMgt",
  },
  {
    key: "redemptionCodeHistoryPage",
    path: "/productMgt/redemptionCodeHistoryPage/index.vue",
    component: () => import("@/views/productMgt/redemptionCodeHistoryPage/index.vue"),
    module: "productMgt",
  },
  {
    key: "appBlacklistPage",
    path: "/productMgt/appBlackList/index.vue",
    component: () => import("@/views/productMgt/appBlacklistPage/index.vue"),
    module: "productMgt",
  },
  {
    key: "deviceResourceAllocation",
    path: "/productMgt/deviceResourceAllocationPage/index.vue",
    component: () => import("@/views/productMgt/deviceResourceAllocation/index.vue"),
    module: "productMgt",
  },
  {
    key: "productOperationPage",
    path: "/productMgt/productOperationPage/index.vue",
    component: () => import("@/views/productMgt/productOperationPage/index.vue"),
    module: "productMgt",
  },
    {
    key: "deviceResourceAllocationPage",
    path: "/productMgt/deviceResourceAllocation/index.vue",
    component: () => import("@/views/productMgt/deviceResourceAllocation/index.vue"),
    module: "productMgt",
  },
  {
    key: "appStoreMgt",
    path: "/productMgt/appStoreMgt/index.vue",
    component: () => import("@/views/productMgt/appStoreMgt/index.vue"),
    module: "productMgt",
  },

  {
    key: "cloudPhoneCapture",
    path: "/productMgt/cloudPhoneCapture/index.vue",
    component: () => import("@/views/productMgt/cloudPhoneCapture/index.vue"),
    module: "productMgt",
    
  },
  // 大客户管理模块
  {
    key: "vipCustomerMgtPage",
    path: "/vipClientMgt/vipCustomerMgtPage/index.vue",
    component: () => import("@/views/vipClientMgt/vipCustomerMgtPage/index.vue"),
    module: "vipClientMgt",
  },
  {
    key: "vipClientDataPage",
    path: "/vipClientMgt/vipClientDataPage/index.vue",
    component: () => import("@/views/vipClientMgt/vipClientDataPage/index.vue"),
    module: "vipClientMgt",
  },
  {
    key: "vipClientIncomePage",
    path: "/vipClientMgt/vipClientIncomePage/index.vue",
    component: () => import("@/views/vipClientMgt/vipClientIncomePage/index.vue"),
    module: "vipClientMgt",
  },
  {
    key: "vipClientIncomeStatisticsPage",
    path: "/vipClientMgt/keyAccountStatisticsPage/index.vue",
    component: () => import("@/views/vipClientMgt/keyAccountStatisticsPage/index.vue"),
    module: "vipClientMgt",
  },
  {
    key: "keyAccountManagerStatisticsPage",
    path: "/vipClientMgt/keyAccountManagerStatisticsPage/index.vue",
    component: () => import("@/views/vipClientMgt/keyAccountManagerStatisticsPage/index.vue"),
    module: "vipClientMgt",
  },
  {
    key: "vipCustomerManagerPage",
    path: "/vipClientMgt/vipCustomerManagerPage/index.vue",
    component: () => import("@/views/vipClientMgt/vipCustomerManagerPage/index.vue"),
    module: "vipClientMgt",
  },
  {
    key: "customPricePayPage",
    path: "/userMgt/customPricePayPage/index.vue",
    component: () => import("@/views/userMgt/customPricePayPage/index.vue"),
    module: "userMgt",
  },

  // 内容管理模块
  {
    key: "activityPage",
    path: "/contentMgt/activityPage/index.vue",
    component: () => import("@/views/contentMgt/activityPage/index.vue"),
    module: "contentMgt",
  },
  {
    key: "articlesPage",
    path: "/contentMgt/articlesPage/index.vue",
    component: () => import("@/views/contentMgt/articlesPage/index.vue"),
    module: "contentMgt",
  },
  {
    key: "helpCenterPage",
    path: "/contentMgt/helpCenterPage/index.vue",
    component: () => import("@/views/contentMgt/helpCenterPage/index.vue"),
    module: "contentMgt",
  },
  {
    key: "protocolMgtPage",
    path: "/contentMgt/protocolMgtPage/index.vue",
    component: () => import("@/views/contentMgt/protocolMgtPage/index.vue"),
    module: "contentMgt",
  },

  // 代理平台模块
  {
    key: "userAgentPlatformPage",
    path: "/agentPlatformMgt/userAgentPlatformPage/index.vue",
    component: () => import("@/views/agentPlatformMgt/userAgentPlatformPage/index.vue"),
    module: "agentPlatformMgt",
  },
  {
    key: "withdrawalPage",
    path: "/agentPlatformMgt/withdrawalPage/index.vue",
    component: () => import("@/views/agentPlatformMgt/withdrawalPage/index.vue"),
    module: "agentPlatformMgt",
  },
  {
    key: "accountStatementPage",
    path: "/agentPlatformMgt/accountStatementPage/index.vue",
    component: () => import("@/views/agentPlatformMgt/accountStatementPage/index.vue"),
    module: "agentPlatformMgt",
  },
  {
    key: "agentConfigPage",
    path: "/agentPlatformMgt/agentConfigPage/index.vue",
    component: () => import("@/views/agentPlatformMgt/agentConfigPage/index.vue"),
    module: "agentPlatformMgt",
  },
    {
    key: "rebateActivityPage",
    path: "/agentPlatformMgt/rebateActivityPage/index.vue",
    component: () => import("@/views/agentPlatformMgt/rebateActivityPage/index.vue"),
    module: "agentPlatformMgt",
  },
    {
    key: "promotionMatrialMgtPage",
    path: "/agentPlatformMgt/promotionMatrialMgtPage/index.vue",
    component: () => import("@/views/agentPlatformMgt/promotionMatrialMgtPage/index.vue"),
    module: "agentPlatformMgt",
  },
  {
    key: "agentCodePricePage",
    path: "/agentPlatformMgt/agentCodePricePage/index.vue",
    component: () => import("@/views/agentPlatformMgt/agentCodePricePage/index.vue"),
    module: "agentPlatformMgt",
  },
  {
    key: "proxyLevelPage",
    path: "/agentPlatformMgt/proxyLevelPage/index.vue",
    component: () => import("@/views/agentPlatformMgt/proxyLevelPage/index.vue"),
    module: "agentPlatformMgt",
  },
  {
    key: "proxyCodeOrderMgt",
    path: "/agentPlatformMgt/proxyCodeOrderMgt/index.vue",
    component: () => import("@/views/agentPlatformMgt/proxyCodeOrderMgt/index.vue"),
    module: "agentPlatformMgt",
  },

  // 客户端管理模块
  {
    key: "clientVersionPage",
    path: "/clientMgt/clientVersionPage/index.vue",
    component: () => import("@/views/clientMgt/clientVersionPage/index.vue"),
    module: "clientMgt",
  },
  {
    key: "onLineUserPage",
    path: "/clientMgt/onLineUserPage/index.vue",
    component: () => import("@/views/clientMgt/onLineUserPage/index.vue"),
    module: "clientMgt",
  },

  // 数据分析模块
  {
    key: "orderStatisticsPage",
    path: "/dataAnalysisMgt/orderStatisticsPage/index.vue",
    component: () => import("@/views/dataAnalysisMgt/orderStatisticsPage/index.vue"),
    module: "dataAnalysisMgt",
  },
  {
    key: "appOrderListPage",
    path: "/dataAnalysisMgt/appOrderListPage/index.vue",
    component: () => import("@/views/dataAnalysisMgt/appOrderListPage/index.vue"),
    module: "dataAnalysisMgt",
  },
  {
    key: "todaySalesVolumePage",
    path: "/dataAnalysisMgt/todaySalesVolumePage/index.vue",
    component: () => import("@/views/dataAnalysisMgt/todaySalesVolumePage/index.vue"),
    module: "dataAnalysisMgt",
  },
  {
    key: "historicalSalesDataPage",
    path: "/dataAnalysisMgt/historicalSalesDataPage/index.vue",
    component: () => import("@/views/dataAnalysisMgt/historicalSalesDataPage/index.vue"),
    module: "dataAnalysisMgt",
  },
  {
    key: "userChannelsPage",
    path: "/dataAnalysisMgt/userChannelsPage/index.vue",
    component: () => import("@/views/dataAnalysisMgt/userChannelsPage/index.vue"),
    module: "dataAnalysisMgt",
  },
   {
    key: "historicalChannelsPage",
    path: "/dataAnalysisMgt/historicalChannelsPage/index.vue",
    component: () => import("@/views/dataAnalysisMgt/historicalChannelsPage/index.vue"),
    module: "dataAnalysisMgt",
  },
    {
    key: "userStatisticsPage",
    path: "/dataAnalysisMgt/userStatisticsPage/index.vue",
    component: () => import("@/views/dataAnalysisMgt/userStatisticsPage/index.vue"),
    module: "dataAnalysisMgt",
  },
      {
    key: "userRetentionStatisticsPage",
    path: "/dataAnalysisMgt/userRetentionStatisticsPage/index.vue",
    component: () => import("@/views/dataAnalysisMgt/userRetentionStatisticsPage/index.vue"),
    module: "dataAnalysisMgt",
  },
  {
    key: "deviceStatisticsPage",
    path: "/dataAnalysisMgt/deviceStatisticsPage/index.vue",
    component: () => import("@/views/dataAnalysisMgt/deviceStatisticsPage/index.vue"),
    module: "dataAnalysisMgt",
  },
  {
    key: "expireDeviceStatisticsPage",
    path: "/dataAnalysisMgt/expireDeviceStatisticsPage/index.vue",
    component: () => import("@/views/dataAnalysisMgt/expireDeviceStatisticsPage/index.vue"),
    module: "dataAnalysisMgt",
  },
  {
    key: "deviceInventoryPage",
    path: "/dataAnalysisMgt/deviceInventoryPage/index.vue",
    component: () => import("@/views/dataAnalysisMgt/deviceInventoryPage/index.vue"),
    module: "dataAnalysisMgt",
  },
  {
    key: "userBehaviorStatisticsPage",
    path: "/dataAnalysisMgt/userBehaviorStatistics/index.vue",
    component: () => import("@/views/dataAnalysisMgt/userBehaviorStatistics/index.vue"),
    module: "dataAnalysisMgt",
  },
   {
    key: "orderDashboardPage",
    path: "/dataAnalysisMgt/orderDashboardPage/index.vue",
    component: () => import("@/views/dataAnalysisMgt/orderDashboardPage/index.vue"),
    module: "dataAnalysisMgt",
  },
   {
    key: "userDashboardPage",
    path: "/dataAnalysisMgt/userDashboardPage/index.vue",
    component: () => import("@/views/dataAnalysisMgt/userDashboardPage/index.vue"),
    module: "dataAnalysisMgt",
  },
  {
    key: "appDashboardPage",
    path: "/dataAnalysisMgt/appDashboardPage/index.vue",
    component: () => import("@/views/dataAnalysisMgt/appDashboardPage/index.vue"),
    module: "dataAnalysisMgt",
  },

  // 代理IP管理模块
  {
    key: "IPManagement",
    path: "/proxyIpMgt/IPManagementPage/index.vue",
    component: () => import("@/views/proxyIpMgt/IPManagement/index.vue"),
    module: "proxyIpMgt",
  },

  // 登录相关（保留自原有的映射）
  {
    key: "emptyPage",
    path: "/loginMgt/emptyPage/index.vue",
    component: () => import("@/views/loginMgt/emptyPage/index.vue"),
    module: "loginMgt",
  },
];

/**
 * 获取组件路径的辅助函数
 * @param componentKey 组件键名
 * @returns 组件路径或导入的组件
 */
export function getComponentPath(componentKey: string): any {
  const data = componentPathArray.find(ele => ele.path.includes(componentKey));
  return data?.component || '';
}